var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { getToken } from '@/utils/getToken';
import { useCallback, useMemo, useState } from 'react';
import { useConfigContext } from '../context';
function useApi(url) {
    var _this = this;
    var _a = useState(null), data = _a[0], setData = _a[1];
    var _b = useState(null), error = _b[0], setError = _b[1];
    var _c = useState(false), loading = _c[0], setLoading = _c[1];
    var _d = useConfigContext().config, apiBaseUrl = _d.apiBaseUrl, tokenKey = _d.tokenKey, appIdentifier = _d.appIdentifier, customerSecretKey = _d.customerSecretKey;
    console.log('tokenKey------>', tokenKey);
    var authToken = getToken(tokenKey) ||
        getToken('cookie.vriti-dev-access-token') ||
        getToken('cookie.vriti-sit-access-token') ||
        getToken('cookie.vriti-production-access-token');
    console.log('authToken------>', authToken);
    var headerConfig = useMemo(function () {
        var headers = {
            app_identifier: appIdentifier,
            secret_key: customerSecretKey,
        };
        if (authToken) {
            headers.Authorization = "Bearer ".concat(authToken);
        }
        return headers;
    }, [authToken, appIdentifier, customerSecretKey]);
    var fetchData = useCallback(function () { return __awaiter(_this, void 0, void 0, function () {
        var response, json, err_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setLoading(true);
                    setError(null);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 4, 5, 6]);
                    return [4 /*yield*/, fetch("".concat(apiBaseUrl).concat(url), {
                            headers: headerConfig,
                        })];
                case 2:
                    response = _a.sent();
                    if (!response.ok) {
                        throw new Error("Error: ".concat(response.status, " ").concat(response.statusText));
                    }
                    return [4 /*yield*/, response.json()];
                case 3:
                    json = _a.sent();
                    setData(json);
                    return [3 /*break*/, 6];
                case 4:
                    err_1 = _a.sent();
                    setError(err_1.message);
                    return [3 /*break*/, 6];
                case 5:
                    setLoading(false);
                    return [7 /*endfinally*/];
                case 6: return [2 /*return*/];
            }
        });
    }); }, [url, headerConfig, apiBaseUrl]);
    var createItem = function (item) { return __awaiter(_this, void 0, void 0, function () {
        var response, err_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setLoading(true);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 4, 5, 6]);
                    return [4 /*yield*/, fetch("".concat(apiBaseUrl).concat(url), {
                            method: 'POST',
                            headers: __assign({ 'Content-Type': 'application/json' }, headerConfig),
                            body: JSON.stringify(item),
                        })];
                case 2:
                    response = _a.sent();
                    if (!response.ok) {
                        throw new Error("Error: ".concat(response.status, " ").concat(response.statusText));
                    }
                    return [4 /*yield*/, fetchData()];
                case 3:
                    _a.sent();
                    return [3 /*break*/, 6];
                case 4:
                    err_2 = _a.sent();
                    setError(err_2.message);
                    return [3 /*break*/, 6];
                case 5:
                    setLoading(false);
                    return [7 /*endfinally*/];
                case 6: return [2 /*return*/];
            }
        });
    }); };
    var updateItem = function (item, onSuccess) { return __awaiter(_this, void 0, Promise, function () {
        var response, err_3;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setLoading(true);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, 4, 5]);
                    return [4 /*yield*/, fetch("".concat(apiBaseUrl).concat(url), {
                            method: 'PUT',
                            headers: __assign({ 'Content-Type': 'application/json' }, headerConfig),
                            body: JSON.stringify(item),
                        })];
                case 2:
                    response = _a.sent();
                    if (!response.ok) {
                        throw new Error("Error: ".concat(response.status, " ").concat(response.statusText));
                    }
                    onSuccess === null || onSuccess === void 0 ? void 0 : onSuccess();
                    return [3 /*break*/, 5];
                case 3:
                    err_3 = _a.sent();
                    setError(err_3.message);
                    return [3 /*break*/, 5];
                case 4:
                    setLoading(false);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    var deleteItem = function (id) { return __awaiter(_this, void 0, void 0, function () {
        var res, response, _a, err_4;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    setLoading(true);
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 5, 6, 7]);
                    return [4 /*yield*/, fetch("".concat(apiBaseUrl).concat(url, "&id=").concat(id), {
                            method: 'DELETE',
                            headers: headerConfig,
                        })];
                case 2:
                    response = _b.sent();
                    _a = [{}];
                    return [4 /*yield*/, response.json()];
                case 3:
                    res = __assign.apply(void 0, [__assign.apply(void 0, _a.concat([(_b.sent())])), { status: response.status === 200 ? 'success' : 'error' }]);
                    if (!response.ok) {
                        throw new Error("".concat((res === null || res === void 0 ? void 0 : res.message) || 'Failed to delete item'));
                    }
                    return [4 /*yield*/, fetchData()];
                case 4:
                    _b.sent();
                    return [3 /*break*/, 7];
                case 5:
                    err_4 = _b.sent();
                    console.error('Error deleting item:', err_4);
                    setError(err_4.message);
                    res = {
                        status: 'error',
                        message: err_4.message,
                    };
                    return [3 /*break*/, 7];
                case 6:
                    setLoading(false);
                    return [7 /*endfinally*/];
                case 7: return [2 /*return*/, res];
            }
        });
    }); };
    return { data: data, error: error, loading: loading, fetchData: fetchData, createItem: createItem, updateItem: updateItem, deleteItem: deleteItem };
}
export default useApi;
